export default ".footer-logo { max-width: 160px;\n}\n"